import { TeamMenu } from '@/types/menu';

export function getCurrentTeamMenu(pathname: string): TeamMenu | undefined {
  // HOMEかどうか
  const regex_home = /^\/teams\/[^/]+\/?$/;
  if (regex_home.test(pathname)) {
    return 'HOME';
  }

  // チームノートかどうか
  const regex_teams_notes = /^\/teams\/[^/]+\/notes$/;
  if (regex_teams_notes.test(pathname)) {
    return 'NOTE';
  }

  // チームノートかどうか（目標・課題）
  const regex_teams_members_goals = /^\/teams\/[^/]+\/goals$/;
  if (regex_teams_members_goals.test(pathname)) {
    return 'NOTE';
  }

  // 所属メンバーかどうか
  const regex_teams_members = /^\/teams\/[^/]+\/members(\/.*)?$/;
  if (regex_teams_members.test(pathname)) {
    return 'MEMBER';
  }

  // チーム設定(for Owner)かどうか
  const regex_teams_owner_settings = /^\/teams\/[^/]+\/settings\/owner-settings$/;
  if (regex_teams_owner_settings.test(pathname)) {
    return 'TEAM_SETTINGS';
  }

  // チーム設定(for Member)かどうか
  const regex_teams_member_settings = /^\/teams\/[^/]+\/settings\/member-settings($|\/)/;
  if (regex_teams_member_settings.test(pathname)) {
    return 'TEAM_SETTINGS';
  }

  return undefined;
}
